import { observer } from 'mobx-react';
import React, { FC, useEffect, useState } from 'react';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

import { IconButton, InputAdornment, Typography } from '@material-ui/core';

import { ReactComponent as CopyIcon } from '@assets/images/icons/copyAccountBlack.svg';
import OysterButton from '@components/common/Button';
import Input from '@components/common/Input/index';
import { appUrl } from '@configs/variables';
import useAccountsPayable from '@hooks/useAccountsPayable';
import useStore from '@hooks/useStore';
import { emailsSeparatedCommas } from '@utils/validators';

import useStyles from './styles';

export interface IEmailSend {}

const EmailSend: FC<IEmailSend> = () => {
  const { accountsPayableLink } = useStore();
  const { accountsPayableLinkId, isSubmitting } = accountsPayableLink;
  const css = useStyles();
  const search = useLocation().search;
  const confirmParam = new URLSearchParams(search).get('confirm');
  const baseUrl = `${appUrl}/accounts-payable/`;
  const url = `${baseUrl}${accountsPayableLinkId}?confirm=true`;
  const [emails, setEmails] = useState('');
  const [emailsError, setEmailsError] = useState(false);
  const { openSendRequestModal, handleError, showSuccessToast } = useAccountsPayable();
  const { t } = useTranslation();

  useEffect(() => {
    if (emails) {
      setEmailsError(!emailsSeparatedCommas(emails.replace(/ /g, '')));
    } else {
      setEmailsError(false);
    }
  }, [emails]);

  const fetchSendEmails = async () => {
    try {
      if (emails && !emailsError) {
        await accountsPayableLink.requestFunds(emails.split(','));
        showSuccessToast({
          title: t('accountsPayable.toast.success.title'),
          message: t('accountsPayable.toast.success.sendEmail'),
        });
      }
    } catch (error) {
      handleError(error as { message: string });
    }
  };
  const handleChangeEmails = (event: { target: { value: React.SetStateAction<string> } }) => {
    setEmails(event.target.value);
  };
  const SendEmailButton = () => (
    <OysterButton
      className={css.button}
      onClick={fetchSendEmails}
      loading={isSubmitting}
      disabled={isSubmitting}
      label={t('accountsPayable.send')}
    />
  );

  const handleOnCopy = () => {
    showSuccessToast({
      title: t('accountsPayable.toast.success.title'),
      message: t('accountsPayable.toast.success.copyUrl'),
    });
  };

  return (
    <div className={css.card}>
      <div className={css.emailSendContainer}>
        <Typography className={css.cardTitle}>Compartir enlace</Typography>
        <Typography className={css.cardSubTitle}>Copia y comparte el siguiente enlace</Typography>
        <CopyToClipboard text={url} onCopy={handleOnCopy}>
          <div className={css.container}>
            <Input
              className={css.urlInput}
              fullWidth
              autoComplete="off"
              disabled={true}
              value={url}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton aria-label="toggle password visibility">
                      <CopyIcon className={css.icon} />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </div>
        </CopyToClipboard>
        <p className={css.optionalText}>
          <span>O</span>
        </p>
        <Typography className={css.cardTitle}>Enviar por enlace por correo</Typography>
        <Typography className={css.cardSubTitle}>
          Agregar varios correos separados por comas
        </Typography>
        <Input
          fullWidth
          id="outlined-basic"
          variant="outlined"
          onChange={handleChangeEmails}
          InputProps={{
            classes: {
              input: css.resize,
            },
            endAdornment: <SendEmailButton />,
          }}
          value={emails}
          error={emailsError}
        />
      </div>
    </div>
  );
};

export default observer(EmailSend);
